import {IPersonalCapsuleEvaluation} from '../types';
import s from './personalCapsuleEvaluationItemList.module.css';
import { useState } from "react";

export default function PersonalCapsuleEvaluationItemList({ evaluation }: { evaluation: IPersonalCapsuleEvaluation }) {
    const [isOpen, setIsOpen] = useState(false);

    const changeOpen = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={s.card}>
            <div className={s.header} onClick={changeOpen}>
                <div className={s.userInfo}>
                    <span className={s.userName}>{evaluation.userName}</span>
                    <span className={s.userEmail}>{evaluation.userEmail}</span>
                </div>
                <div className={s.date}>
                    <span className={s.userName}>{evaluation.dateCreated}</span>
                </div>
            </div>
            <div className={s.evaluationBlock}>
                <div className={s.ratingHeading}>
                    <img className={s.iconMark} src={evaluation.mark === "GOOD" ? "/like.png" : "/dislike.png"}/>
                </div>
                <div className={s.feedback}>
                    <div className={s.phrases}>
                        {evaluation.whatWrong.map((phrase: string, i: number) => (
                            <span key={i} className={s.phraseTag}>{phrase}</span>
                        ))}
                    </div>
                    {evaluation.whatConsider && (
                        <p className={s.review}>"{evaluation.whatConsider}"</p>
                    )}
                </div>
            </div>
        </div>
    );
}